import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";
import { IssuesBoard } from "#app/components/issues/issues-board";
import type { IssueScope } from "#app/lib/filters/issue-scope";

/** `/team/$teamId/board` — the team's Kanban across its workflows (read-only). */
function TeamBoardRoute() {
  const { teamId } = Route.useParams();
  const scope = useMemo<IssueScope>(
    () => ({ kind: "team", teamId }),
    [teamId],
  );
  return <IssuesBoard scope={scope} />;
}

export const Route = createFileRoute("/(app)/$workspace/team/$teamId/board")({
  component: TeamBoardRoute,
});
